<footer>
    <div class="row">
      <div class="col-lg-12">
        <hr />
        <div class="row">
          <div class="col-4"></div>
          <div class="col-4" style="min-height:11px;"><p-progressBar *ngIf="isHttpActive" mode="indeterminate"></p-progressBar></div>
          <div class="col-4"></div>
        </div>
        <br />
        <div class="text-center pb-3">
          V4.3.5 powered by © Applied Resources Engineering {{currentYear}}
        </div>
      </div>
    </div>
  </footer>
